module.exports = __webpack_public_path__ + "img/vue-01-09.e870ca79.png";